// A file's place in its upload batch, or undefined for a file outside the batch.
const createUploadRankLookup = (batch: string[]) => {
  const ranks = new Map(batch.map((id, index) => [id, index]));
  return (uploaderId: string | undefined) => (uploaderId !== undefined ? ranks.get(uploaderId) : undefined);
};

export default createUploadRankLookup;
